import { ftToMm, getEmptyImperialNumber, inToMm, mmToImperial } from './number-converter';

export class ImperialInputHandler {
  constructor(node, options = {}) {
    if (!node) {
      return;
    }

    this._node = node;
    this._initInputs();
  }

  _initInputs() {
    let hasSomeInput = false;
    this._inputs = [];
    const feet = this.node.querySelector('.imperial-input-feet');
    if (feet) {
      hasSomeInput = true;
      this._inputFeet = feet;
      if (this._inputFeet?.type === 'text') {
        this._initFeetTextInput(this._inputFeet);
      }
      this._inputs.push(this._inputFeet);
    }
    const inch = this.node.querySelector('.imperial-input-inch');
    if (inch) {
      hasSomeInput = true;
      this._inputInch = inch;
      this._inputs.push(this._inputInch);
    }
    const fraction = this.node.querySelector('.imperial-input-fraction');
    if (fraction) {
      hasSomeInput = true;
      this._inputFraction = fraction;
      this._inputs.push(this._inputFraction);
    }
    const sign = this.node.querySelector('.imperial-input-sign');
    if (sign) {
      this._inputSign = sign;
      this._inputs.push(this._inputSign);
    }

    if (!hasSomeInput) {
      console.error('Imperial input group has no inputs defined.');
      return false;
    }

    return true;
  }

  _initFeetTextInput(input) {
    input.parentNode.addEventListener('click', () => {
      input.focus();
    });
    input.addEventListener('focus', () => {
      input.select();
    });
    input.addEventListener('keyup', e => {
      let value = input.value;
      value.replace(/\D/g, '');
      value = Number.parseInt(value);
      value = isNaN(value) ? '' : value;
      input.value = value;
    });
  }

  _setImperialValue(imperial) {
    if (this._inputFeet) {
      this._inputFeet.value = imperial.feet ? imperial.feet : '';
    }
    if (this._inputInch) {
      this._inputInch.value = imperial.inch ? imperial.inch : '';
    }
    if (this._inputFraction) {
      this._inputFraction.value =
        imperial.fraction.numerator > 0 ? `${imperial.fraction.numerator}/${imperial.fraction.denominator}` : '';
    }
  }

  reset() {
    this._setImperialValue(getEmptyImperialNumber());
  }

  get value() {
    const imperial = this.valueImperial;
    return parseInt(
      `${imperial.sign}${
        ftToMm(imperial.feet) +
        inToMm(imperial.inch) +
        inToMm(imperial.fraction.numerator / imperial.fraction.denominator)
      }`
    );
  }

  set value(mm) {
    const imperial = mmToImperial(mm);
    this._setImperialValue(imperial);
  }

  get valueImperial() {
    const imperial = getEmptyImperialNumber();
    imperial.feet = parseInt(this._inputFeet?.value ? this._inputFeet?.value : 0);
    imperial.inch = parseInt(this._inputInch?.value ? this._inputInch?.value : 0);
    imperial.sign = this._inputSign?.value ? this._inputSign?.value : '';
    imperial.fraction = this._parseFraction(this._inputFraction?.value ? this._inputFraction?.value : '');
    return imperial;
  }

  get node() {
    return this._node;
  }

  _parseFraction(fractionString) {
    const fraction = {
      numerator: 0,
      denominator: 16,
    };

    if (!fractionString.length) {
      return fraction;
    }

    const [numerator, denominator] = fractionString.split('/');
    if (!denominator || isNaN(numerator) || isNaN(denominator) || parseFloat(denominator) === 0) {
      return fraction;
    }
    fraction.numerator = parseInt(numerator);
    fraction.denominator = parseInt(denominator);
    return fraction;
  }

  addEventListener() {}

  focus() {
    this._inputs[0].focus();
  }

  select() {}
}
